var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14831",
    "data-name": "Rectangle 14831",
    width: 15.472,
    height: 15.472,
    fill: "#185edf",
    stroke: "#5e708d",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74818",
    "data-name": "Group 74818",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5505",
    "data-name": "Ellipse 5505",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(-0.306)",
    fill: "#e8eaee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30324",
    "data-name": "Group 30324",
    transform: "translate(3.041 3.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1075",
    "data-name": "Mask Group 1075",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14830",
    "data-name": "Rectangle 14830",
    width: 13.925,
    height: 15.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.458 0.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20090",
    "data-name": "Path 20090",
    d: "M13.583,3.38a.8.8,0,0,1-.175.519A.474.474,0,0,1,13,4.093H9.5a.618.618,0,0,1-.583-.648V2.8H7.167v.648a.618.618,0,0,1-.583.648H3.112A.636.636,0,0,1,2.5,3.509a.8.8,0,0,1,.175-.519A.474.474,0,0,1,3.083,2.8H6V2.148A.618.618,0,0,1,6.583,1.5H9.5a.618.618,0,0,1,.583.648V2.8h2.888a.636.636,0,0,1,.613.583Z",
    transform: "translate(-2.5 -1.5)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20091",
    "data-name": "Path 20091",
    d: "M12.065,8.083l-.7,7.843h-4.9l-.7-7.843A.61.61,0,0,0,5.181,7.5h0a.559.559,0,0,0-.435.212.7.7,0,0,0-.149.5l.758,8.426a.61.61,0,0,0,.583.583h5.95a.61.61,0,0,0,.583-.583l.758-8.426a.7.7,0,0,0-.149-.5.559.559,0,0,0-.435-.212h0A.61.61,0,0,0,12.065,8.083Z",
    transform: "translate(-3.373 -3.611)",
    fill: "#185edf"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete-icon.b3528ee5e6d7a2463540018f19912a1a.svg";
export { ForwardRef as ReactComponent };